<template>
  <narrow-container>
    <div
      id="loading"
      :class="{'show':inProgress}"
    />
    <h1 class="headline-secondary text--center">
      {{ this.$i18n.t('LOGIN.HEADER') }}
    </h1>
    <h1 class="headline-sub text--center">
      {{ this.$i18n.t('LOGIN.INFO.P1') }}
    </h1>
    <p>{{ this.$i18n.t('LOGIN.INFO.P2') }}</p>
    <validated-input-box
      id="loginFieldLogin"
      ref="loginField"
      :validation-reg-exp="numberRegex"
      :validation-error-message="$i18n.t('COMMON.ERROR_MESSAGES.LOGIN_ERROR')"
      :label="this.$i18n.t('LOGIN.LOGIN_NUMBER')"
      placeholder="6789123456789"
      name="loginField"
    />
    <input-box
      id="passwordField"
      ref="passwordField"
      :label="this.$i18n.t('LOGIN.PASSWORD')"
      name="passwordField"
      type="password"
    />
    <submit-button
      id="loginSubmitButton"
      :label="this.$i18n.t('LOGIN.LOGIN')"
      :on-click="login"
      :disabled="!frcResponse"
    />
    <friendly-captcha-field
      ref="captcha"
      v-model="frcResponse"
    />
    <accordion
      id="first-hint"
      :label="this.$i18n.t('LOGIN.INFO0.FIND_PASSWORD')"
    >
      <p>
        {{ this.$i18n.t('LOGIN.INFO0.P1') }}
      </p>
      <div class="img-container">
        <img
          class="img-small"
          src="@/assets/image/Streamingkarte_Mockup.png"
        >
      </div>
    </accordion>
    <list-link
      to="passwordReset"
      :label="this.$i18n.t('LOGIN.INFO1.FORGOT_PASSWORD')"
    />
    <list-link
      to="forgottenLogin"
      :label="this.$i18n.t('LOGIN.INFO2.FORGOT_LOGIN')"
    />
  </narrow-container>
</template>

<script>
import Regex from '@/constants/regex.json';
import FriendlyCaptchaField from '@/components/common/FriendlyCaptchaField.vue';

const RESP_OK = 0;
const RESP_VALIDATION_ERROR = 1;
const RESP_MSISDN_NOT_PREPAID = 2;
const RESP_PASSWORD_INCORRECT = 3;
const RESP_TEMPORARILY_LOCKED = 4;
const RESP_LOCKED = 5;
const RESP_NOT_REGISTERED = 6;
const RESP_ACTIVATION_IN_PROGRESS = 7;
const RESP_INCORRECT_SUBSCRIBER_TYPE = 8;
const RESP_OTHER_ERROR = 9999;
const FIVE_SECONDS = 1000*5;
const APP_TYPE_DREI_TV = 1;

export default {
  name: 'Login',
  components: { FriendlyCaptchaField },
  data: function() {
    return {
      inProgress: false,
      frcResponse: null,
    };
  },
  computed: {
    numberRegex: function() {
      return Regex.NUMBER;
    }
  },
  mounted: function() {
    const loginCredentials = this.$store.getters.loginCredentials;
    if (loginCredentials) {
      this.$store.commit("clearLoginCredentials");
      this.$refs.loginField.setFieldValue(loginCredentials.msisdn);
      this.$refs.passwordField.setFieldValue(loginCredentials.password);
      this.performAutomaticLogin(loginCredentials);
    }
  },
  methods: {
    isFormValid: function() {
      const isValid = this.$refs.loginField.isValidBeforeSubmit()
        && this.$refs.passwordField.getFieldValue() != "";
      return isValid;
    },
    login: function() {
      if (!this.inProgress && this.isFormValid() && this.$refs.captcha.isValid()) {
        this.inProgress = true;
        const loginCredentials = {
          msisdn: this.$refs.loginField.getFieldValue(),
          password: this.$refs.passwordField.getFieldValue(),
          appType: APP_TYPE_DREI_TV
        };

        var routeName = this.resolveRouteName();
        this.callLogin(loginCredentials, routeName);
      }
    },
    callLogin: function(loginCredentials, routeName) {
      this.$http.post('api/protected/accessToken', loginCredentials, { 
        headers: {
          'friendly-captcha-version': 'v2',
          'friendly-captcha-response': this.frcResponse
        }
      })
        .then( response => {

          if(response.data.responseCode === RESP_ACTIVATION_IN_PROGRESS) {
            this.waitForActivation(loginCredentials, 1);
          } else {
            this.processSuccessfulCallResponse(response, routeName);
            this.inProgress = false;
          }
        })
        .catch(callData => {
          this.processErrorCallResponse(callData);
          this.inProgress = false;
          this.$refs.captcha.reset();
        })
    },
    processSuccessfulCallResponse: function(response, routeName) {
      let loginResponse = response.data;
      this.$store.commit('setUserDetail', loginResponse.userDetail);
      this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login',label: 'Success', value: 0, noninteraction: false });
      this.$router.push({name: routeName});
    },
    processErrorCallResponse: function(callData) {
      if(callData.response === undefined || callData.response.data === undefined) {
        //this.$store.dispatch("googleAnalytics/createGoogleAnalyticsEvent", {eventCategory: 'Account', eventAction: 'App Login', eventLabel: 'Error - Technical issue - no data'});
        this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
        this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login',label: 'Error - no data', value: 0, noninteraction: false });
        return;
      }

      let responseCode = callData.response.data.responseCode;

      switch(responseCode) {
        case RESP_VALIDATION_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('LOGIN.ERROR_MESSAGES.CREDENTIALS_INCORRECT'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login',label: 'Error - validation', value: 0, noninteraction: false });
          break;
        case RESP_PASSWORD_INCORRECT:
          this.$store.commit("setErrorMessage", this.$i18n.t('LOGIN.ERROR_MESSAGES.CREDENTIALS_INCORRECT'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login',label: 'Error - incorrect password', value: 0, noninteraction: false });
          break;
        case RESP_TEMPORARILY_LOCKED:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.LOGIN_TEMPORARILY_LOCKED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login',label: 'Error - temporarily locked', value: 0, noninteraction: false });
          break;
        case RESP_LOCKED:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.LOGIN_LOCKED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login',label: 'Error - locked', value: 0, noninteraction: false });
          break;
        case RESP_NOT_REGISTERED:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.SUBSCRIPTION_NOT_YET_REGISTERED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login',label: 'Error - not registered', value: 0, noninteraction: false });
          break;
        case RESP_MSISDN_NOT_PREPAID:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.MSISDN_NOT_ACTIVE_PREPAID'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login',label: 'Error - not active prepaid', value: 0, noninteraction: false });
          break;
        case RESP_INCORRECT_SUBSCRIBER_TYPE:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.MSISDN_NOT_ACTIVE_PREPAID'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login',label: 'Error - invalid subscriber type', value: 0, noninteraction: false });
          break;
        case RESP_OTHER_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login',label: 'Error - technical issue', value: 0, noninteraction: false });
          break;
        default:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login',label: 'Error - '+responseCode, value: 0, noninteraction: false });
      }
    },
    performAutomaticLogin: function(loginCredentials) {
      this.inProgress = true;
      const credentials = {msisdn: loginCredentials.msisdn, password: loginCredentials.password, appType: APP_TYPE_DREI_TV};
      this.waitForActivation(credentials, 1)
    },
    waitForActivation: function(loginCredentials, attemptNum) {
      var self = this;
      self.$http.get('api/dreitvkarte/active', {params: { login: loginCredentials.msisdn}})
        .then( response => {
          if(response.data.responseCode === RESP_OK) {
            self.callLogin(loginCredentials, 'topUp');
          } else {
            if (attemptNum%12 == 0) {
              self.$store.commit("setWarningMessage", self.$i18n.t('LOGIN.WAIT'));
            }
            setTimeout(function() {self.waitForActivation(loginCredentials, attemptNum++)}, FIVE_SECONDS);
          }
        })
        .catch(callData => {
            self.inProgress = false;
            this.processErrorCallResponse(callData);
        })

    },
    //loginRedirectName is set in axios interceptor in case user was accesing logged in part when not logged in.
    resolveRouteName: function() {
      var routeName = this.$store.getters.loginRedirectName;
      this.$store.commit('clearLoginRedirectName');
      if (routeName == '') routeName = 'manage';
      return routeName;
    }
  },
};
</script>

<style lang="scss">
    .icon-chevron-right:before {
        right: 0px !important;;
    }
    .list-link-label {
        font-size: 18px !important;
     }
</style>
<style lang="scss" src="@/components/loading/loading.scss">
</style>
<style lang="scss" src="@/components/img.scss">
</style>
